import request from '../utils/fetch'
export function selectList (data) {
  return request({
    url: '/banner/selectListAdmin',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function addBanner (data) {
  return request({
    url: '/banner/addBanner',
    method: 'post',
    requestBody: 'body',
    loading: true,
    data: data
  })
}
export function updateBanner (data) {
  return request({
    url: '/banner/updateBanner',
    method: 'post',
    requestBody: 'body',
    loading: true,
    data: data
  })
}
export function deleteOne (data) {
  return request({
    url: '/banner/deleteOne',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function updateBannerSort (data) {
  return request({
    url: '/banner/updateBannerSort',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}
export function updateState (data) {
  return request({
    url: '/banner/updateState',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}



